const RepairFileOriginTypeConstant = {
  STORE: 'STORE',
  KEY_ACCOUNT: 'KEY_ACCOUNT'
}

export default RepairFileOriginTypeConstant
